import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { useState, useEffect } from 'react';
import { MdRadioButtonUnchecked, MdRadioButtonChecked } from 'react-icons/md';

import { productsForOrder } from '../../store/cart';

import styles from './ProductChoices.module.scss';

export default function ProductChoices({ product, setProduct, config, isProductMYO }) {
  const [optionSelected, setOptionSelected] = useState();

  function updateCart(_option = optionSelected) {
    const optionObject = [
      {
        _id: _option?._id,
        label: _option?.label,
      },
    ];
    const productWithOptions = {
      ...product,
      options: optionObject,
    };
    setProduct(productWithOptions);
    const productsInCart = productsForOrder.getValue();
    if (isEmpty(productsInCart)) return;
    const productsInCartOption = productsInCart.map(_product => {
      if (_product._id !== product._id) return _product;
      return productWithOptions;
    });
    productsForOrder.update(productsInCartOption);
  }

  function onClickOption(_option) {
    setOptionSelected(_option);
    updateCart(_option);
  }

  useEffect(() => {
    if (isProductMYO) {
      const defaultOption = product.options ? product.options[0] : config.options[0];
      setOptionSelected(defaultOption);
    }
  }, [isProductMYO, product]);

  if (!isProductMYO) return null;

  return (
    <div>
      <p className={styles.optionsTitle}>{config.label}</p>
      <div className={styles.optionsLargeContainer}>
        {config.options.map(option => (
          <button
            key={option._id}
            className={cn({
              [styles.btnOptions]: optionSelected?.label !== option.label,
              [styles.btnSelected]: optionSelected?.label === option.label,
            })}
            onClick={() => onClickOption(option)}
          >
            {optionSelected?.label === option.label ? <MdRadioButtonChecked className={styles.radioSelected} />
              : <MdRadioButtonUnchecked className={styles.radio}/>}
            <span>{option.label}</span>
          </button>
        ))}
      </div>
      <div className={styles.optionsSmallContainer}>
        {config.options.map(option => (
          <div key={option._id} className={styles.optionsSmallSceen}>
            <button className={styles.radioOptions} onClick={() => onClickOption(option)}>
              {optionSelected?.label === option.label ? <MdRadioButtonChecked className={styles.radioSmallSelected} />
                : <MdRadioButtonUnchecked className={styles.radioSmall}/>}
            </button>
            <span>{option.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
